/**
 * @generated SignedSource<<b8c7021d283b5fca341480c41cf91402>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RemoveStartTreeConfigInput = {
  clientMutationId?: string | null | undefined;
  configId: string;
  rootNodeId: string;
};
export type StartTreeConfigEditor_RemoveStartTreeConfigMutation$variables = {
  input: RemoveStartTreeConfigInput;
};
export type StartTreeConfigEditor_RemoveStartTreeConfigMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly removeStartTreeConfig: {
        readonly rootNode: {
          readonly " $fragmentSpreads": FragmentRefs<"StartTreeConfigEditor_TreeNodeFragment">;
        };
      } | null | undefined;
    };
  };
};
export type StartTreeConfigEditor_RemoveStartTreeConfigMutation = {
  response: StartTreeConfigEditor_RemoveStartTreeConfigMutation$data;
  variables: StartTreeConfigEditor_RemoveStartTreeConfigMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StartTreeConfigEditor_RemoveStartTreeConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "RemoveStartTreeConfigPayload",
                "kind": "LinkedField",
                "name": "removeStartTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "StartTreeConfigEditor_TreeNodeFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StartTreeConfigEditor_RemoveStartTreeConfigMutation",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminMutationType",
        "kind": "LinkedField",
        "name": "Admin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TreeAdminMutationSchema",
            "kind": "LinkedField",
            "name": "Tree",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "RemoveStartTreeConfigPayload",
                "kind": "LinkedField",
                "name": "removeStartTreeConfig",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TreeNode",
                    "kind": "LinkedField",
                    "name": "rootNode",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "structureDefinition",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "startConfigs",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "configType",
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "TypeDiscriminator",
                                    "abstractKey": "__isStartTreeConfig"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "dateTime",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "userStatuses",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "SpecifiedUserStatusesCanStartTreeConfig",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "userRoles",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "SpecifiedUserRolesCanStartTreeConfig",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "RootStructureDefinition",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b658eff6ec167b4625eead6c21b3f86a",
    "id": null,
    "metadata": {},
    "name": "StartTreeConfigEditor_RemoveStartTreeConfigMutation",
    "operationKind": "mutation",
    "text": "mutation StartTreeConfigEditor_RemoveStartTreeConfigMutation(\n  $input: RemoveStartTreeConfigInput!\n) {\n  Admin {\n    Tree {\n      removeStartTreeConfig(input: $input) {\n        rootNode {\n          ...StartTreeConfigEditor_TreeNodeFragment\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ProjectExtendStartTreeConfigEditDialogs_StartTreeConfigFragment on StartTreeConfig {\n  __isStartTreeConfig: __typename\n  configType\n  ...SpecificUserStatusesCanStartTreeConfigForm_StartTreeConfigFragment\n  ...SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment\n}\n\nfragment ProjectExtendStartTreeConfigEditDialogs_TreeNodeFragment on TreeNode {\n  ...SpecificUserStatusesCanStartTreeConfigForm_TreeNodeFragment\n  ...SpecificUserRolesCanStartTreeConfigForm_TreeNodeFragment\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      startConfigs {\n        __typename\n        configType\n        ... on SpecifiedUserStatusesCanStartTreeConfig {\n          userStatuses\n          dateTime\n        }\n        ... on SpecifiedUserRolesCanStartTreeConfig {\n          userRoles\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment on StartTreeConfig {\n  __isStartTreeConfig: __typename\n  ... on SpecifiedUserRolesCanStartTreeConfig {\n    id\n    configType\n    userRoles\n  }\n}\n\nfragment SpecificUserRolesCanStartTreeConfigForm_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      startConfigs {\n        __typename\n        ...SpecificUserRolesCanStartTreeConfigForm_StartTreeConfigFragment\n        id\n      }\n    }\n  }\n}\n\nfragment SpecificUserStatusesCanStartTreeConfigForm_StartTreeConfigFragment on StartTreeConfig {\n  __isStartTreeConfig: __typename\n  ... on SpecifiedUserStatusesCanStartTreeConfig {\n    id\n    configType\n    dateTime\n    userStatuses\n  }\n}\n\nfragment SpecificUserStatusesCanStartTreeConfigForm_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      startConfigs {\n        __typename\n        ...SpecificUserStatusesCanStartTreeConfigForm_StartTreeConfigFragment\n        id\n      }\n    }\n  }\n}\n\nfragment StartTreeConfigEditor_TreeNodeFragment on TreeNode {\n  id\n  structureDefinition {\n    __typename\n    ... on RootStructureDefinition {\n      startConfigs {\n        __typename\n        id\n        configType\n        ...ProjectExtendStartTreeConfigEditDialogs_StartTreeConfigFragment\n      }\n    }\n  }\n  ...ProjectExtendStartTreeConfigEditDialogs_TreeNodeFragment\n}\n"
  }
};
})();

(node as any).hash = "e599c5f8501c394b2c051e43b723da23";

export default node;
